import { render, staticRenderFns } from "./Atividades.vue?vue&type=template&id=b6541c12"
import script from "./Atividades.vue?vue&type=script&lang=js"
export * from "./Atividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports